export default __webpack_public_path__ + "static/media/superiorpro.bb0c93ed.png";